import React, { useState } from 'react'
import NovelsLogoWhite from './images/NovelsLogoWhite.png'
import ChevronUp from '../../components/Images/ChevronUp'
import ImportantNoteIcon from '../../components/Images/ImportantNoteIcon'
import Certificate from './images/Certificate.png'
import CertificateLogo from './images/Certificate.webp'
import Trophy from './images/Trophy.webp'
import headphonewithnote from './images/headphonewithnote.svg'
import { chooseContestObject } from './contestData'
import {
  BannerContainer,
  Container,
  BannerHeadingLogo,
  BannerContent,
  BtnContainer,
  BannerButton,
  Button,
  BannerHeading,
  BannerHeadingContainer,
  BannerSubHeading,
  SectionsContainer,
  SectionsCommonHeading,
  StageAndPrizeCardContainer,
  CardContainer,
  CardWrapper,
  StageCardHeading,
  StageTable,
  StageSubHeading,
  CardChevronBtn,
  FlexContainer,
  NotesPoints2,
  MinWidthSetter,
  VerticalCenterItems,
  ParticipationCerticiate,
  ViewParticipationLogo,
  Rank4And5,
  FlexContianerForStoryPoints,
  NotesFlexItem,
  BulbLogoContainer,
  TipsHeading,
  StoryWritingPoints,
  StagePrizeContainer,
  Prize2and3Image,
  PrizeSubheading,
  BannerButtonContainer,
  Prizelogo,
  NotesButtonForMobile,
  NoteChangeButton,
  PrizeImg,
  SuspenseNovelsContainer,
  NovelContent,
  HeadphoneLogo,
  LiveContainer,
  Dot,
  DummyCertificateSection,
  DummyCertificateSectionForMobile,
  ExtraPadding,
  ExampleNovelImg,
  Rank123Container,
} from './style'

import { handleEventLog, redirectToNovelLinkHandler } from '../../lib/utils'

const onCreateBookClick = (contestId, defaultReferrer, visibility) => {
  window.localStorage.setItem('contestId', contestId)
  handleEventLog('writer_contest', 'button_click', {
    route: window.location.pathname + window.location.search,
    button: 'join_contest_button',
  })
  const queryString = window.location.search
  const params = new URLSearchParams(queryString)
  const referrer = params.get('referrer') || defaultReferrer
  if (window.localStorage.getItem('uid'))
    window.location.href = `/shows/novels/?referrer=${referrer}&open-new=1`
  else
    window.location.href = `/${
      visibility === 'row' ? 'globalLogin' : ''
    }?referrer=${referrer}`
}

const toggleExtraInfoHandler = (e) => {
  const extraInfoElement = e.currentTarget.previousElementSibling
  if (extraInfoElement.style.maxHeight === '6rem') {
    extraInfoElement.style.maxHeight = `${extraInfoElement.scrollHeight}px`
    extraInfoElement.style.webkitTextFillColor = `var(--Text500)`
  } else {
    extraInfoElement.style.maxHeight = '6rem'
    extraInfoElement.style.webkitTextFillColor = `transparent`
  }
  e.currentTarget.classList.toggle('open')
}


const showNovelHandler = (novelId) => {
  redirectToNovelLinkHandler(novelId)
}

const WinnersPageStatusLog = [
  {
    Name: 'campus-diaries-universal-hindi',
    isWinnersPageLive: false,
    isStage2WinnersLive: false,
    isWinnersPageLiveText: false,
  },
]

const Template2 = ({ title, ...props }) => {
  const { isWinnersPageLive } = WinnersPageStatusLog.find(
    (contest) => contest.Name === title
  )

  const [currentNotePoint, setCurrentNotePoint] = useState(1)
  const [toggleViewCertificate, setToggleViewCertificate] = useState(false)
  const [activeTab, setActiveTab] = useState('winner')
  if (!chooseContestObject[title]) {
    props.history.push('/contest')
    return null
  }
  const {
    storyPoints,
    StageContent,
    exampleNovels,
    constants,
  } = chooseContestObject[title]
  const handleViewCertificate = () => {
    setToggleViewCertificate(!toggleViewCertificate)
  }
  return (
    <Container>
      <BannerContainer
        BannerDesktopImage={constants.BannerDesktopImage}
        BannerMobileImage={constants.BannerMobileImage}
      >
        <BannerContent>
          <BannerHeadingLogo>
            <img src={NovelsLogoWhite} alt='Pocket Novel' />
          </BannerHeadingLogo>
          <BannerHeadingContainer>
            <BannerHeading>
              {constants.heading}
              <br />
            </BannerHeading>
            <BannerSubHeading>{constants.subHeading}</BannerSubHeading>
          </BannerHeadingContainer>
          {(isWinnersPageLive || constants.contestId) && (
            <BannerButtonContainer>
              {!isWinnersPageLive && (
                <BannerButton
                  onClick={() =>
                    onCreateBookClick(
                      constants.contestId,
                      constants.defaultReferrer,
                      constants.visibility
                    )
                  }
                  activeTabColor
                >
                  {constants.bannerButton}
                </BannerButton>
              )}
              {isWinnersPageLive && (
                <BannerButton
                  onClick={() => setActiveTab('detail')}
                  activeTabColor={activeTab === 'detail'}
                >
                  {' '}
                  Contest Details{' '}
                </BannerButton>
              )}
              {isWinnersPageLive && (
                <BannerButton
                  onClick={() => setActiveTab('winner')}
                  activeTabColor={activeTab === 'winner'}
                >
                  {' '}
                  Winners{' '}
                </BannerButton>
              )}
            </BannerButtonContainer>
          )}
        </BannerContent>
      </BannerContainer>
      {(activeTab === 'detail' || !isWinnersPageLive) && (
        <SectionsContainer>
          <ExtraPadding>
            <section>
              <SectionsCommonHeading>
                {' '}
                {constants.section_1_Heading}{' '}
              </SectionsCommonHeading>
              <StageAndPrizeCardContainer>
                {StageContent.map((data, index) => {
                  const {
                    bgColor,
                    headingbgColor,
                    stageheading,
                    stageSubHeading,
                    tableContent,
                    stageContent,
                    prizeHeading,
                    firstPrize,
                    secondPrize,
                    thirdPrize,
                    rank4And5Prize,
                    isLive,
                    rank1Prize,
                    rank2Prize,
                    rank3Prize,
                    lowerRankCombinedPrizeTitle,
                  } = data
                  return (
                    <div key={index}>
                      {' '}
                      <CardContainer backgroundColor={bgColor}>
                        <CardWrapper>
                          <StageCardHeading backgroundColor={headingbgColor}> {stageheading}{' '} </StageCardHeading>
                          <StageSubHeading> {stageSubHeading}  
                            <LiveContainer color={isLive ? '#54b585' : 'var(--Punch500)'}> 
                              {' '} <Dot bgColor={isLive ? '#54b585' : 'var(--Punch500)'}/> &nbsp;{isLive ? 'LIVE' : 'ENDED'}
                            </LiveContainer>
                          </StageSubHeading>
                          <StageTable>
                            <tbody>
                              {tableContent.map((content, i) => (
                                <tr key={i}>
                                  <td>
                                    {content.title}
                                    <span role="img">{content.img}</span>
                                  </td>
                                  <td>{content.date}</td>
                                </tr>
                              ))}
                            </tbody>
                          </StageTable>

                          <FlexContainer>
                            <MinWidthSetter>
                              <ImportantNoteIcon width='34' height='34' />
                            </MinWidthSetter>
                            <div>
                              <NotesPoints2>{stageContent}</NotesPoints2>
                              <CardChevronBtn onClick={toggleExtraInfoHandler}>
                                <ChevronUp
                                  width="24"
                                  height="24"
                                  fillOpacity="1"
                                />
                              </CardChevronBtn>
                            </div>
                          </FlexContainer>
                        </CardWrapper>
                        <VerticalCenterItems>
                          {firstPrize && (
                            <StagePrizeContainer>
                              <PrizeImg>
                                <img src={firstPrize} alt=""/>
                              </PrizeImg>
                            </StagePrizeContainer>
                          )}
                          {secondPrize && (
                            <StagePrizeContainer>
                              <Prize2and3Image src={secondPrize} />
                              <Prize2and3Image src={thirdPrize} />
                            </StagePrizeContainer>
                          )}
                          {rank1Prize && (
                            <>
                              <Rank123Container>
                                <Prizelogo src={Trophy} />
                                {lowerRankCombinedPrizeTitle || (<>Rank 1 - </>)}
                                <span role="img">💸</span> {rank1Prize}
                              </Rank123Container>
                              <Rank123Container>
                                <Prizelogo src={Trophy} />
                                {lowerRankCombinedPrizeTitle || (<>Rank 2 - </>)}
                                <span role="img">💸</span> {rank2Prize}
                              </Rank123Container>
                              <Rank123Container>
                                <Prizelogo src={Trophy} />
                                {lowerRankCombinedPrizeTitle || (<>Rank 3 - </>)}
                                <span role="img">💸</span> {rank3Prize}
                              </Rank123Container>
                            </>
                          )}
                          <Rank4And5>
                            <Prizelogo src={Trophy} />
                            {lowerRankCombinedPrizeTitle || (<>Rank 4th & 5th - </>)}
                            <span role="img">💸</span> {rank4And5Prize}
                          </Rank4And5>
                          {constants.showCertificateLink && (
                            <ParticipationCerticiate
                              href={constants.participation_certificate_image}
                              download="certificate"
                              onClick={() => handleViewCertificate()}
                            >
                              {' '}
                              <ViewParticipationLogo
                                src={CertificateLogo}
                              />{' '}
                              View Participation Certificate
                            </ParticipationCerticiate>
                          )}
                          {toggleViewCertificate && (
                            <DummyCertificateSectionForMobile>
                              <SectionsCommonHeading>
                                {constants.section_2_Heading}
                              </SectionsCommonHeading>
                              <img src={Certificate} width='100%' alt=""/>
                            </DummyCertificateSectionForMobile>
                          )}
                          {constants.stageButton && (
                            <BtnContainer>
                              <Button
                                onClick={() =>
                                  onCreateBookClick(
                                    constants.contestId,
                                    constants.defaultReferrer,
                                    constants.visibility
                                  )
                                }
                              >
                                {constants.stageButton}
                              </Button>
                            </BtnContainer>
                          )}
                        </VerticalCenterItems>
                      </CardContainer>
                      {prizeHeading && (
                        <>
                          {' '}
                          <PrizeSubheading>
                            {constants.prizeSubheading}
                            <HeadphoneLogo src={headphonewithnote} />
                          </PrizeSubheading>
                        </>
                      )}
                    </div>
                  )
                })}
              </StageAndPrizeCardContainer>
            </section>
            {constants.showCertifiicateImg && (
              <DummyCertificateSection>
                <SectionsCommonHeading>
                  {constants.section_2_Heading}
                </SectionsCommonHeading>
                <img src={Certificate} width='100%' alt=""/>
              </DummyCertificateSection>
            )}
            <section>
              <SectionsCommonHeading>
                {constants.section_3_Heading}
              </SectionsCommonHeading>
              <SuspenseNovelsContainer>
                {exampleNovels.map((novel, index) => (
                  <NovelContent key={index}>
                    <ExampleNovelImg
                      src={novel.novelImgLink}
                      alt={novel.title}
                    />
                    <Button onClick={() => showNovelHandler(novel.novelId)}>
                      {constants.novelContent}
                    </Button>
                  </NovelContent>
                ))}
              </SuspenseNovelsContainer>
            </section>

            <section>
              <SectionsCommonHeading>
                {constants.section_4_Heading}
              </SectionsCommonHeading>
              <FlexContianerForStoryPoints>
                {storyPoints.map((data) => {
                  const display = data.key === currentNotePoint ? 'block' : 'none'
                  return (
                    <NotesFlexItem key={data.key} display={display}>
                      <BulbLogoContainer>
                        <ImportantNoteIcon />
                      </BulbLogoContainer>
                      <TipsHeading>TIP {data.key}</TipsHeading>
                      <StoryWritingPoints> {data.point}</StoryWritingPoints>
                    </NotesFlexItem>
                  )
                })}
              </FlexContianerForStoryPoints>
              <NotesButtonForMobile>
                {storyPoints.map((data, index) => (
                    <NoteChangeButton
                      key={index}
                      onClick={() => setCurrentNotePoint(data.key)}
                      isActive={data.key === currentNotePoint}
                      data={index}
                    >
                      {data.key}
                    </NoteChangeButton>
                  )
                )}
              </NotesButtonForMobile>
            </section>
          </ExtraPadding>

        </SectionsContainer>
      )}
    </Container>
  )
}

export default Template2
